<template>
  <BaseModal modal-id="modalAlert" :show-modal="props.showRenewRegModalActive" :allow-esc="bindEscKey">
    <template #heading>Transaction confirmation</template>
    <template #content>
      <div class="app-modal-basic">
        <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
        <div>
          <p>This will cancel your current in-work transaction. Are you sure?</p>
        </div>
      </div>
    </template>
    <template #footing>
      <BaseButtonGroup>
        <template #default>
          <button @click.prevent="handleSecondaryButton()">
            No
          </button>
          <button class="app-btn-primary" @click.prevent="handlePrimaryButton()">
            Yes
          </button>
        </template>
      </BaseButtonGroup>
    </template>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '@/components/ui/BaseModal';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';

// Props
const props = defineProps({
  showRenewRegModalActive: {
    type: Boolean,
    required: true,
  },
});

// Emitted events
const emit = defineEmits(['getRenewRegShowStatus']);

const bindEscKey = ref(false);

// Methods
const handlePrimaryButton = () => {
  emit('getRenewRegShowStatus', 'Yes');
};

const handleSecondaryButton = () => {
  emit('getRenewRegShowStatus', 'No');
};
</script>


<style lang="scss" scoped>
// TODO: should have been picked up from @ridmv/web-themes but it's not...
.app-modal-basic {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  img {
    margin: 1em 0.5em 0 0;
    width: 1.25rem;
  }
  p {
    &:first-child {
      @extend %font-sans-bold;
      font-size: 1.25rem;
    }
    &:not(first-child) {
      @extend %font-sans-semibold;
    }
  }
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
